module.exports = __webpack_public_path__ + "static/media/sparrow-with-kalli.ef64a435.gif";